import * as React from 'react';

import { projectSelector } from 'src/selectors/project';
import { useNavigate } from 'src/utils/hooks/useNavigate';
import { useReduxSelector } from 'src/utils/hooks/useReduxSelector';
import { getProjectRoute } from 'src/utils/routes/getProjectRoute';

/**
 * Sets a project id to navigate to once the project exists in the redux state.
 * Otherwise, navigating to a non-existent project will redirect to the home page
 */
export const useNavigateProject = () => {
  const navigate = useNavigate();
  const [projectId, setProjectId] = React.useState<string>('');
  const project = useReduxSelector(projectSelector(projectId));

  React.useEffect(() => {
    if (projectId && project) {
      navigate(getProjectRoute(projectId));
      setProjectId('');
    }
  }, [navigate, project, projectId]);

  return setProjectId;
};
